export interface PageBackgroundBranding {
  backgroundColor?: string | null;
}

export function buildPageBackgroundCssRules(
  s: string,
  branding: PageBackgroundBranding | null | undefined,
): string[] {
  const color = branding?.backgroundColor;
  if (!color) return [];
  return [
    `${s}[data-ui="portal-page-wrapper"] { background-color: ${color}; }`,
  ];
}
